import styled from 'styled-components'
import { grayDark, grayDarker } from '@bufferapp/ui/style/colors'

import { fadeIn } from '~/shared/styles/animations'
import { flexRow } from '~/shared/styles/layout'
import { baseFont } from '~/shared/styles/font'

/**
 *
 */

export const Wrapper = styled.div`
  ${flexRow}
  align-items: flex-start;
  width: 100%;
  padding: 8px;
  position: relative;
  ${(props) =>
    // @ts-expect-error TS(2339) FIXME: Property 'animated' does not exist on type 'Themed... Remove this comment to see the full error message
    props.animated ? fadeIn : null}
`

export const Status = styled.p`
  position: absolute;
  bottom: 16px;
  right: 0px;
  ${baseFont}
  color: ${grayDarker};
`

export const ImageContainer = styled.div`
  width: 80px;
  height: 80px;
  margin-right: 8px;
`

export const InfoContainer = styled.div`
  flex: 1;

  > * {
    margin-bottom: 8px;
  }
`

export const CountersContainer = styled.div`
  ${flexRow}

  > * {
    margin-right: 16px;
  }
`

export const TimeAgo = styled.p`
  ${baseFont}
  font-size: 10px;
  line-height: 12px;
  margin: 0px;
  color: ${grayDark};
`

export const PlaceholderWrapper = styled.div`
  width: 100%;
`
